import i18n from '@hapana/shared/web/i18n'

export const ROUTES = {
  dashboard: {
    path: '',
    title: i18n.t('core:dashboard.title'),
    resourcePath: 'home',
  },
  home2: {
    path: 'home-2',
    title: i18n.t('core:routes.home2'),
    resourcePath: 'home-2',
  },
  login: {
    path: 'login',
  },
  logout: {
    path: 'logout',
  },
  loginAs: {
    path: 'login-as',
  },
  locationSelection: {
    path: '/location-selection',
    title: i18n.t('core:locationSelection.title'),
    resourcePath: 'location-selection',
  },
  locationSettingsRedirect: {
    path: 'location-settings',
    redirectTo: 'settings',
  },
  controlCenter: {
    path: 'control-center',
    title: i18n.t('core:controlCenter.title'),
    resourcePath: 'control-center',
    children: {
      communicationTemplates: {
        path: 'control-center/communication-templates',
        title: i18n.t('core:controlCenter.communicationTemplates.cardTitle'),
        resourcePath: 'communication-templates',
      },
      faqs: {
        path: 'control-center/faqs',
        title: i18n.t('core:controlCenter.faqs.cardTitle'),
        resourcePath: 'faqs',
      },
      integrations: {
        path: 'control-center/integrations',
        title: i18n.t('core:controlCenter.integrations.cardTitle'),
        resourcePath: 'integrations',
      },
      apiIntegrations: {
        path: 'control-center/api-integrations',
        title: i18n.t('core:controlCenter.apiIntegrations.cardTitle'),
        resourcePath: 'api-integrations',
        children: {
          apiIntegrationsTabs: {
            path: 'control-center/api-integrations/:tab',
            resourcePath: 'api-integrations',
            title: i18n.t('core:controlCenter.apiIntegrations.cardTitle'),
          },
        },
      },
      scheduler: {
        path: 'control-center/scheduler',
        title: i18n.t('core:controlCenter.scheduler.cardTitle'),
        resourcePath: 'scheduler',
      },
      retailSalesSettings: {
        path: 'control-center/retail-settings',
        title: i18n.t('core:controlCenter.retailSettings.cardTitle'),
        resourcePath: 'retail-settings',
      },
      retailGeneralSettings: {
        path: 'control-center/retail-settings',
        title: i18n.t('core:controlCenter.retailGeneralSettings.cardTitle'),
        resourcePath: 'retail-settings',
      },
      brandCustomization: {
        path: 'control-center/brand-customization',
        title: i18n.t('core:controlCenter.brandCustomization.cardTitle'),
        resourcePath: 'brand-customization',
      },
      auditHistory: {
        path: 'control-center/audit-history',
        title: i18n.t('core:controlCenter.auditHistory.cardTitle'),
        resourcePath: 'audit-history',
      },
      onboarding: {
        path: 'control-center/onboarding',
        title: i18n.t('core:controlCenter.onboarding.cardTitle'),
        resourcePath: 'onboarding',
        children: {
          migrationWizard: {
            path: 'control-center/onboarding/:migrationId',
            title: i18n.t('core:controlCenter.onboarding.wizardTitle'),
            resourcePath: 'onboarding',
          },
        },
      },
      selfService: {
        path: 'control-center/self-service',
        title: i18n.t('core:controlCenter.selfService.cardTitle'),
        resourcePath: 'self-service',
      },
    },
  },
  product: {
    path: 'product',
    title: i18n.t('core:routes.product'),
    resourcePath: 'product',
    children: {
      eventTracker: {
        path: 'product/event-tracker',
        title: i18n.t('core:routes.eventTracker'),
        resourcePath: 'event-tracker',
      },
      dynamicLoaderDemo: {
        path: 'product/dynamic-loader-demo',
        title: i18n.t('core:routes.dynamicLoaderDemo'),
        resourcePath: 'dynamic-loader-demo',
      },
    },
  },
  notFound: {
    path: '*',
  },
  userProfile: {
    path: 'profile',
  },
  clients: {
    path: 'clients',
    pathWithSlash: '/clients',
    title: i18n.t('core:routes.clients'),
    resourcePath: 'clients',
    children: {
      clientOverview: {
        path: 'clients/:clientId',
        pathWithSlash: '/clients',
        title: i18n.t('core:routes.clientOverview'),
        resourcePath: 'client-overview',
      },
    },
  },
  siteTeamAccess: {
    path: 'team-access',
    title: i18n.t('core:routes.teamAccess'),
    resourcePath: 'team-access',
  },
  userAccess: {
    path: 'user-access',
    title: i18n.t('core:routes.userAccess'),
    resourcePath: 'user-access',
    children: {
      userAccessTabs: {
        path: 'user-access/:tab',
        resourcePath: 'user-access',
      },
    },
  },
  retail: {
    path: 'retail',
    title: i18n.t('core:retailDashboard.title'),
    resourcePath: 'retail',
  },
  settings: {
    path: 'settings',
    title: i18n.t('core:settings.title'),
    resourcePath: 'settings',
    children: {
      locationSettings: {
        path: 'settings/location-settings',
        title: i18n.t('core:settings.systemSettings.locationSettings.title'),
        resourcePath: 'location-settings',
        children: {
          locationSettingsTabs: {
            path: 'settings/location-settings/:tab',
            resourcePath: 'location-settings',
            title: i18n.t('core:settings.systemSettings.locationSettings.title'),
          },
          roomResourceConfiguration: {
            path: 'settings/location-settings/room-resource-configuration',
            title: i18n.t(
              'core:settings.systemSettings.locationSettings.configuration.roomResourceConfiguration'
            ),
            resourcePath: 'room-resource-configuration',
          },
          siteCommunicationTemplates: {
            path: 'settings/location-settings/site-communication-templates',
            title: i18n.t(
              'core:settings.systemSettings.locationSettings.siteCommunicationTemplates'
            ),
            resourcePath: 'site-communication-templates',
          },
        },
      },
      schedulerSettings: {
        path: 'settings/scheduler-settings',
        title: i18n.t('core:settings.scheduler.title'),
        resourcePath: 'scheduler-settings',
        children: {
          schedulerSettingsTabs: {
            path: 'settings/scheduler-settings/:tab',
            resourcePath: 'scheduler-settings',
            title: i18n.t('core:settings.systemSettings.schedulerSettings.title'),
          },
        },
      },
      retailSettings: {
        path: 'settings/retail-settings',
        title: i18n.t('core:settings.retail.title'),
        resourcePath: 'retail-settings',
        children: {
          retailSettingsTabs: {
            path: 'settings/retail-settings/:tab',
            resourcePath: 'retail-settings',
            title: i18n.t('core:settings.retail.title'),
          },
        },
      },
      accountSettings: {
        path: 'settings/account-settings',
        title: i18n.t('core:settings.account.title'),
        resourcePath: 'account-settings',
        children: {
          accountSettingsTabs: {
            path: 'settings/account-settings/:tab',
            resourcePath: 'account-settings',
            title: i18n.t('core:settings.account.title'),
          },
        },
      },
      wellnessSettings: {
        path: 'settings/wellness-settings',
        title: i18n.t('core:settings.cards.wellness.cardTitle'),
        resourcePath: 'wellness-settings',
        children: {
          wellnessSettingsTabs: {
            path: 'settings/wellness-settings/:tab',
            resourcePath: 'wellness-settings',
            title: i18n.t('core:settings.cards.wellness.cardTitle'),
          },
        },
      },
    },
  },

  assistant: {
    path: 'assistant',
    title: i18n.t('core:routes.assistant'),
    resourcePath: 'assistant',
    children: {
      search: {
        path: 'assistant/search',
        title: i18n.t('core:routes.assistantSearch'),
        resourcePath: 'assistant-search',
      },
      chats: {
        path: 'assistant/chats',
        title: i18n.t('core:routes.assistantChats'),
        resourcePath: 'assistant-chats',
      },
      support: {
        path: 'assistant/support',
        title: i18n.t('core:routes.assistantSupport'),
        resourcePath: 'assistant-support',
      },
      docs: {
        path: 'assistant/docs',
        title: i18n.t('core:routes.assistantDocs'),
        resourcePath: 'assistant-docs',
      },
      activity: {
        path: 'assistant/activity',
        title: i18n.t('core:routes.assistantActivity'),
        resourcePath: 'assistant-activity',
      },
    },
  },
  helpDocs: {
    path: 'help-docs',
    title: i18n.t('core:helpDocs.title'),
    resourcePath: 'help-docs',
    children: {
      article: {
        path: 'help-docs/:slug',
        title: i18n.t('core:helpDocs.articleTitle'),
        resourcePath: 'help-docs-article',
      },
    },
  },
  mobileSetup: {
    path: 'mobile-setup',
    title: i18n.t('common:navigationLinks.mobileSetup', 'Mobile Setup'),
    resourcePath: 'mobile-setup',
  },
  schedule: {
    path: 'schedule',
    title: i18n.t('core:routes.schedule'),
    resourcePath: 'schedule',
  },
  payments: {
    path: 'payments',
    title: i18n.t('core:routes.payments'),
    resourcePath: 'payments',
  },
  reports: {
    path: 'reports',
    title: i18n.t('core:routes.reports'),
    resourcePath: 'reports',
    children: {
      reportsTabs: {
        path: 'reports/:tab',
        title: i18n.t('core:routes.reports'),
        resourcePath: 'reports',
      },
    },
  },
  memberView: {
    path: 'member-view',
    title: 'Member View',
    resourcePath: 'member-view',
  },
  analytics: {
    path: 'analytics',
    title: i18n.t('core:routes.analytics'),
    resourcePath: 'analytics',
  },
  retailDashboard: {
    path: 'retail',
    title: i18n.t('core:retailDashboard.title', 'Retail Dashboard'),
    resourcePath: 'retail',
    children: {
      paymentLog: {
        path: 'retail/payment-log',
        title: i18n.t('core:retailDashboard.paymentLog.title', 'Payment Log'),
        resourcePath: 'payment-log',
      },
      memberships: {
        path: 'retail/memberships',
        title: i18n.t('core:retailDashboard.memberships.title', 'Memberships'),
        resourcePath: 'memberships',
      },
      scheduled: {
        path: 'retail/scheduled',
        title: i18n.t('core:retailDashboard.scheduled.title', 'Scheduled'),
        resourcePath: 'scheduled',
      },
      pos: {
        path: 'retail/pos',
        title: i18n.t('core:retailDashboard.pos.title', 'POS'),
        resourcePath: 'pos',
      },
      giftCard: {
        path: 'retail/gift-card',
        title: i18n.t('core:retailDashboard.giftCard.title', 'Gift Card'),
        resourcePath: 'gift-card',
      },
      failed: {
        path: 'retail/failed',
        title: i18n.t('core:retailDashboard.failed.title', 'Failed Payments'),
        resourcePath: 'failed',
      },
      draftInvoices: {
        path: 'retail/draft-invoices',
        title: i18n.t('core:retailDashboard.draftInvoices.title', 'Draft Invoices'),
        resourcePath: 'draft-invoices',
      },
      payAsYouGo: {
        path: 'retail/pay-as-you-go',
        title: i18n.t('core:retailDashboard.payAsYouGo.title', 'Pay As You Go'),
        resourcePath: 'pay-as-you-go',
      },
      newSale: {
        path: 'retail/new-sale',
        resourcePath: 'new-sale',
        title: i18n.t('core:routes.newSale'),
        children: {
          newSaleTabs: {
            path: 'retail/new-sale/:tab',
            resourcePath: 'new-sale',
            title: i18n.t('core:routes.newSale'),
          },
        },
      },
      checkout: {
        path: 'retail/checkout',
        resourcePath: 'checkout',
        title: i18n.t('core:routes.checkout'),
      },
      paymentDetail: {
        path: 'retail/invoice/:invoiceId',
        resourcePath: 'payment-detail',
        title: i18n.t('core:retailDashboard.paymentDetail.title', 'Payment Details'),
      },
      invoice: {
        path: 'retail/invoice/:invoiceId/invoice',
        resourcePath: 'invoice',
        title: i18n.t('core:retailDashboard.invoice.title', 'Invoice'),
      },
      recurringPaymentDetail: {
        path: 'retail/recurring-payment/:serviceId',
        resourcePath: 'recurring-payment-detail',
        title: i18n.t(
          'core:retailDashboard.recurringPaymentDetail.title',
          'Recurring Payment Detail'
        ),
      },
    },
  },
  contentSuite: {
    path: 'content-suite',
    title: i18n.t('core:contentSuite.listing.title', 'Content Suite'),
    resourcePath: 'content-suite',
    children: {
      contentEntry: {
        path: 'content-suite/:entryId',
        title: i18n.t('core:contentSuite.listing.title', 'Content Suite'),
        resourcePath: 'content-suite-entry',
      },
      mediaLibrary: {
        path: 'content-suite/media',
        title: i18n.t('core:contentSuite.listing.tabs.mediaLibrary', 'Media Library'),
        resourcePath: 'content-suite-media',
      },
      analytics: {
        path: 'content-suite/analytics',
        title: i18n.t('core:contentSuite.listing.tabs.analytics', 'Analytics'),
        resourcePath: 'content-suite-analytics',
      },
    },
  },
  accessDenied: {
    path: 'access-denied',
  },
  requireAuth: {
    path: '',
  },
  zapierConnect: {
    path: 'zapier/connect',
  },
  upgrade: {
    path: 'upgrade',
    title: 'Plans',
    resourcePath: 'upgrade',
  },
}
export const SETTINGS_ROUTES_PATH = [
  ROUTES.settings,
  ROUTES.settings.children.locationSettings,
  ROUTES.settings.children.locationSettings.children.locationSettingsTabs,
  ROUTES.settings.children.locationSettings.children.roomResourceConfiguration,
  ROUTES.settings.children.locationSettings.children.siteCommunicationTemplates,
  ROUTES.settings.children.schedulerSettings,
  ROUTES.settings.children.retailSettings,
  ROUTES.settings.children.retailSettings.children.retailSettingsTabs,
  ROUTES.settings.children.accountSettings,
  ROUTES.settings.children.accountSettings.children.accountSettingsTabs,
]

export const PROTECTED_ROUTES_PATHS = [
  ROUTES.dashboard,
  ROUTES.userAccess,
  ROUTES.userAccess.children.userAccessTabs,
  ROUTES.siteTeamAccess,
  ROUTES.mobileSetup,
  ROUTES.schedule,
  ROUTES.payments,
  ROUTES.reports,
  ROUTES.analytics,
  ROUTES.memberView,
  ROUTES.reports.children.reportsTabs,
  ROUTES.settings,
  ROUTES.settings.children.locationSettings,
  ROUTES.settings.children.locationSettings.children.locationSettingsTabs,
  ROUTES.settings.children.locationSettings.children.roomResourceConfiguration,
  ROUTES.settings.children.locationSettings.children.siteCommunicationTemplates,
  ROUTES.settings.children.schedulerSettings,
  ROUTES.settings.children.retailSettings,
  ROUTES.settings.children.retailSettings.children.retailSettingsTabs,
  ROUTES.settings.children.accountSettings,
  ROUTES.settings.children.accountSettings.children.accountSettingsTabs,
  ROUTES.controlCenter,
  ROUTES.controlCenter.children.faqs,
  ROUTES.controlCenter.children.integrations,
  ROUTES.controlCenter.children.apiIntegrations,
  ROUTES.controlCenter.children.apiIntegrations.children.apiIntegrationsTabs,
  ROUTES.controlCenter.children.communicationTemplates,
  ROUTES.controlCenter.children.auditHistory,
  ROUTES.controlCenter.children.onboarding,
  ROUTES.controlCenter.children.onboarding.children.migrationWizard,
  ROUTES.controlCenter.children.selfService,
  ROUTES.product,
  ROUTES.product.children.eventTracker,
  ROUTES.product.children.dynamicLoaderDemo,
  ROUTES.retailDashboard.children.newSale,
  ROUTES.retailDashboard.children.newSale.children.newSaleTabs,
  ROUTES.retailDashboard.children.checkout,
  ROUTES.helpDocs,
  ROUTES.helpDocs.children.article,
  ROUTES.contentSuite,
  ROUTES.contentSuite.children.contentEntry,
  ROUTES.contentSuite.children.mediaLibrary,
  ROUTES.assistant,
  ROUTES.assistant.children.search,
  ROUTES.assistant.children.chats,
  ROUTES.assistant.children.support,
  ROUTES.assistant.children.docs,
  ROUTES.assistant.children.activity,
  ROUTES.upgrade,
]
